import type { TableColumnConfig, TableColumnVisibility } from '@ipfabric/utils';

export const makeIsColumnVisible =
  (columnVisibility: TableColumnVisibility | undefined) =>
  (column: TableColumnConfig): boolean =>
    columnVisibility?.[column.key] ?? !column.hidden;
